import React, { Component } from 'react'
//more react Projects Button
const loadMoreReactProjects = () => {
	document.getElementById("moreReactProjects").style.display = "block";
	document.getElementById("loadMoreReactProjects").style.display = "none";
	document.getElementById("loadMoreReactProjects2").style.display = "block";
	document.getElementById("loadLessReactProjects").style.display = "block";
	
}
const loadMoreReactProjects2 = () => {
	document.getElementById("moreReactProjects2").style.display = "block";
	document.getElementById("loadMoreReactProjects2").style.display = "none";
	document.getElementById("loadLessReactProjects2").style.display = "block";
	document.getElementById("loadLessReactProjects").style.display = "none";
	
}
const loadLessReactProjects = () => {
	document.getElementById("moreReactProjects").style.display = "none";
	document.getElementById("loadMoreReactProjects2").style.display = "none";
	document.getElementById("loadLessReactProjects").style.display = "none";
	document.getElementById("loadMoreReactProjects").style.display = "block";
	
}
const loadLessReactProjects2 = () => {
	document.getElementById("loadLessReactProjects").style.display = "block";
	document.getElementById("moreReactProjects2").style.display = "none";
	document.getElementById("loadMoreReactProjects2").style.display = "block";
	document.getElementById("loadLessReactProjects2").style.display = "none";
}
// React Native Projects
const loadMoreReactNativeProjects = () => {
	document.getElementById("moreReactNativeProjects").style.display = "block";
	document.getElementById("loadMoreReactNativeProjects").style.display = "none";
	document.getElementById("loadMoreReactNativeProjects2").style.display = "block";
	document.getElementById("loadLessReactNativeProjects").style.display = "block";
	
}
const loadMoreReactNativeProjects2 = () => {
	document.getElementById("moreReactNativeProjects2").style.display = "block";
	document.getElementById("loadMoreReactNativeProjects2").style.display = "none";
	document.getElementById("loadLessReactNativeProjects2").style.display = "block";
	document.getElementById("loadLessReactNativeProjects").style.display = "none";
	
}
const loadLessReactNativeProjects = () => {
	document.getElementById("moreReactNativeProjects").style.display = "none";
	document.getElementById("loadMoreReactNativeProjects2").style.display = "none";
	document.getElementById("loadLessReactNativeProjects").style.display = "none";
	document.getElementById("loadMoreReactNativeProjects").style.display = "block";
	
}
const loadLessReactNativeProjects2 = () => {
	document.getElementById("loadLessReactNativeProjects").style.display = "block";
	document.getElementById("moreReactNativeProjects2").style.display = "none";
	document.getElementById("loadMoreReactNativeProjects2").style.display = "block";
	document.getElementById("loadLessReactNativeProjects2").style.display = "none";
}
// Web Design Projects
const loadMoreWebDesignProjects = () => {
	document.getElementById("moreWebDesignProjects").style.display = "block";
	document.getElementById("loadMoreWebDesignProjects").style.display = "none";
	document.getElementById("loadMoreWebDesignProjects2").style.display = "block";
	document.getElementById("loadLessWebDesignProjects").style.display = "block";
	
}
const loadMoreWebDesignProjects2 = () => {
	document.getElementById("moreWebDesignProjects2").style.display = "block";
	document.getElementById("loadMoreWebDesignProjects2").style.display = "none";
	document.getElementById("loadLessWebDesignProjects2").style.display = "block";
	document.getElementById("loadLessWebDesignProjects").style.display = "none";
	
}
const loadLessWebDesignProjects = () => {
	document.getElementById("moreWebDesignProjects").style.display = "none";
	document.getElementById("loadMoreWebDesignProjects2").style.display = "none";
	document.getElementById("loadLessWebDesignProjects").style.display = "none";
	document.getElementById("loadMoreWebDesignProjects").style.display = "block";
	
}
const loadLessWebDesignProjects2 = () => {
	document.getElementById("loadLessWebDesignProjects").style.display = "block";
	document.getElementById("moreWebDesignProjects2").style.display = "none";
	document.getElementById("loadMoreWebDesignProjects2").style.display = "block";
	document.getElementById("loadLessWebDesignProjects2").style.display = "none";
}
export default class Projects extends Component {
  render() {
    return (
      <div>
		  
				<section className="davidvallejo-work" data-section="projects">
				<h1>Projects</h1>
				<div class="vl"></div>
					<div className="davidvallejo-narrow-content">
						<div className="row">
							<div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
								<span className="heading-meta">Web Apps</span>
								<h2 className="davidvallejo-heading animate-box">React Applications</h2>
							</div>
						</div>
						<div className="row">
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<div className="project" style={{backgroundImage: 'url(images/img-1.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 01</a></h3>
											<span>Website</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-2.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 02</a></h3>
											<span>Animation</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInTop">
								<div className="project" style={{backgroundImage: 'url(images/img-3.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 03</a></h3>
											<span>Illustration</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div id="moreReactProjects" style={{display: 'none'}}>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInBottom">
								<div className="project" style={{backgroundImage: 'url(images/img-4.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 04</a></h3>
											<span>Application</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<div className="project" style={{backgroundImage: 'url(images/img-5.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 05</a></h3>
											<span>Graphic, Logo</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 06</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							</div>
							<div id="moreReactProjects2" style={{display: 'none'}}>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 07</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 08</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 09</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							</div>
						</div>
						<div className="row" id="buttons">
							<div className="col-md-4 animate-box">
							<button id="loadMoreReactProjects" class="big-button" onClick={loadMoreReactProjects} style={{display: 'block'}}>Load more <i className="icon-plus-outline" /></button>
							<button id="loadMoreReactProjects2" class="big-button" onClick={loadMoreReactProjects2} style={{display: 'none'}}>Load more <i className="icon-plus-outline" /></button>
							
							</div>
							<div className="col-md-4 animate-box">
							<button id="loadLessReactProjects" class="big-button" onClick={loadLessReactProjects} style={{display: 'none'}}>Load Less <i className="icon-minus-outline" /></button>
							<button id="loadLessReactProjects2" class="big-button" onClick={loadLessReactProjects2} style={{display: 'none'}}>Load Less<i className="icon-minus-outline" /></button>
							</div>
						</div>
					</div>
					{/*
					React Native row and buttons 
					*/}
					<div className="davidvallejo-narrow-content">
						<div className="row">
							<div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
								<span className="heading-meta">Mobile Apps</span>
								<h2 className="davidvallejo-heading animate-box">React Native Applications</h2>
							</div>
						</div>
						<div className="row">
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<div className="project" style={{backgroundImage: 'url(images/img-1.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 01</a></h3>
											<span>Website</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-2.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 02</a></h3>
											<span>Animation</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInTop">
								<div className="project" style={{backgroundImage: 'url(images/img-3.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 03</a></h3>
											<span>Illustration</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div id="moreReactNativeProjects" style={{display: 'none'}}>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInBottom">
								<div className="project" style={{backgroundImage: 'url(images/img-4.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 04</a></h3>
											<span>Application</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<div className="project" style={{backgroundImage: 'url(images/img-5.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 05</a></h3>
											<span>Graphic, Logo</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 06</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							</div>
							<div id="moreReactNativeProjects2" style={{display: 'none'}}>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 07</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 08</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 09</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							</div>
						</div>
						<div className="row" id="buttons">
							<div className="col-md-4 animate-box">
							<button id="loadMoreReactNativeProjects" class="big-button" onClick={loadMoreReactNativeProjects} style={{display: 'block'}}>Load more <i className="icon-plus-outline" /></button>
							<button id="loadMoreReactNativeProjects2" class="big-button" onClick={loadMoreReactNativeProjects2} style={{display: 'none'}}>Load more <i className="icon-plus-outline" /></button>
							
							</div>
							<div className="col-md-4 animate-box">
							<button id="loadLessReactNativeProjects" class="big-button" onClick={loadLessReactNativeProjects} style={{display: 'none'}}>Load Less <i className="icon-minus-outline" /></button>
							<button id="loadLessReactNativeProjects2" class="big-button" onClick={loadLessReactNativeProjects2} style={{display: 'none'}}>Load Less<i className="icon-minus-outline" /></button>
							</div>
						</div>
					</div>
					{/*
					Web Design row and buttons 
					*/}
					<div className="davidvallejo-narrow-content">
						<div className="row">
							<div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
								<span className="heading-meta">Web Design</span>
								<h2 className="davidvallejo-heading animate-box">WordPress, Elementor,and Adobe XD</h2>
							</div>
						</div>
						<div className="row">
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<div className="project" style={{backgroundImage: 'url(images/img-1.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 01</a></h3>
											<span>Website</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-2.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 02</a></h3>
											<span>Animation</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInTop">
								<div className="project" style={{backgroundImage: 'url(images/img-3.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 03</a></h3>
											<span>Illustration</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div id="moreWebDesignProjects" style={{display: 'none'}}>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInBottom">
								<div className="project" style={{backgroundImage: 'url(images/img-4.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 04</a></h3>
											<span>Application</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<div className="project" style={{backgroundImage: 'url(images/img-5.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 05</a></h3>
											<span>Graphic, Logo</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 06</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							</div>
							<div id="moreWebDesignProjects2" style={{display: 'none'}}>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 07</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 08</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 09</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							</div>
						</div>
						<div className="row" id="buttons">
							<div className="col-md-4 animate-box">
							<button id="loadMoreWebDesignProjects" class="big-button" onClick={loadMoreWebDesignProjects} style={{display: 'block'}}>Load more <i className="icon-plus-outline" /></button>
							<button id="loadMoreWebDesignProjects2" class="big-button" onClick={loadMoreWebDesignProjects2} style={{display: 'none'}}>Load more <i className="icon-plus-outline" /></button>
							
							</div>
							<div className="col-md-4 animate-box">
							<button id="loadLessWebDesignProjects" class="big-button" onClick={loadLessWebDesignProjects} style={{display: 'none'}}>Load Less <i className="icon-minus-outline" /></button>
							<button id="loadLessWebDesignProjects2" class="big-button" onClick={loadLessWebDesignProjects2} style={{display: 'none'}}>Load Less<i className="icon-minus-outline" /></button>
							</div>
						</div>
					</div>
				</section>
      </div>
    )
  }
}